import VRuntimeTemplate from "v-runtime-template";
import bsCustomFileInput from "bs-custom-file-input";
import Vue from 'vue';
import Swiper from 'swiper/dist/js/swiper.js'; // https://github.com/nolimits4web/swiper/issues/2263#issuecomment-339919428
import 'swiper/dist/css/swiper.css';
import VModal from 'vue-js-modal';
import Vuelidate from 'vuelidate';

import GalleryModal from './components/GalleryModal.vue';
import Gallery from './components/Gallery.vue';
import Timer from './components/Timer.vue';
import TimeAgo from './components/TimeAgo.vue';
import LoginForm from './components/LoginForm.vue';
import RegisterForm from './components/RegisterForm.vue';
import RecoverForm from './components/RecoverForm.vue';
import BusinessRequestForm from './components/BusinessRequestForm.vue';
import SubscribeForm from './components/SubscribeForm.vue';

window.Swiper = Swiper;

function toFormData(data) {
    var formData = new FormData();
    for (var key in data) {
        formData.append(key, data[key]);
    }
    return formData;
}

$(document).ready(function () {
    Vue.use(VModal);
    Vue.use(Vuelidate);

    const mixins = [];
    if (typeof mixinGlobal != 'undefined') {
        mixins.push(mixinGlobal);
    }
    if (typeof mixin != 'undefined') {
        mixins.push(mixin);
    }

    window.app = new Vue({
        el: '#app',
        data: {
            isPageReady: false,
            galleryIndex: null,
            galleryItems: [],
            galleryEnableThumbnails: true,
            recaptchaReady: false,
            isTopbarVisible: false,
            scrollWasBlocked: false
        },
        methods: {
            showSidebarLeft() {
                this.$modal.show('sidebar-left');
            },
            showSidebarRight() {
                this.$modal.show('sidebar-right');
            },
            isBlockedScroll() {
                return document.body.classList.contains('v--modal-block-scroll');
            },
            blockScroll() {
                document.body.classList.add('v--modal-block-scroll');
            },
            unblockScroll() {
                document.body.classList.remove('v--modal-block-scroll');
            },
            recaptchaRender(elementId, callback) {
                return this.recaptchaReady && grecaptcha.render(document.getElementById(elementId), {
                    'sitekey' : this.recaptchaKey,
                    'size' : 'invisible',
                    'callback': callback,
                    'error-callback': callback,
                    'expired-callback': callback
                });
            },
            recaptchaExecute(widgetId) {
                if (this.isBlockedScroll()) {
                    this.unblockScroll();
                    this.scrollWasBlocked = true;
                }
                this.recaptchaReady && grecaptcha.execute(widgetId);
            },
            recaptchaReset(widgetId) {
                this.recaptchaReady && grecaptcha.reset(widgetId);
            }
        },
        components: {
            VRuntimeTemplate,
            GalleryModal,
            Gallery,
            Timer,
            TimeAgo,
            LoginForm,
            RegisterForm,
            RecoverForm,
            BusinessRequestForm,
            SubscribeForm,
        },
        mixins: mixins,
        created: function () {
            // fix VueJS content <style> tags removing
            this.styleTagNodeList = document.querySelector(this.$options.el).querySelectorAll('style');
        },
        mounted: function () {
            setTimeout(function () {
                this.isPageReady = true;
            }.bind(this));

            // fix VueJS content <style> tags removing
            for(var i = 0; i < this.styleTagNodeList.length; ++i) {
                this.$el.appendChild(this.styleTagNodeList[i]);
            }
        }
    });


    bsCustomFileInput.init();

});

